/* AUTO-GENERATED by scripts/generate-fight-scenarios.mjs. Do not hand edit. */
import type { ArenaScenarioProfile,ScenarioDressingAsset } from './arenaScenarioTypes'
import { SCENARIO_FAMILY_BY_ARENA } from './generatedWorldExpansion'
export const SCENARIO_ASSET_URLS:Record<ScenarioDressingAsset,string>={
  "woodCrate": "/polyhaven/models/wooden_crate_01.glb",
  "militaryCrate": "/polyhaven/models/old_military_crate.glb",
  "barrel": "/polyhaven/models/Barrel_01.glb",
  "boulder": "/polyhaven/models/boulder_01.glb",
  "barrier": "/polyhaven/models/concrete_road_barrier.glb",
  "statue": "/polyhaven/models/gothic_statue.glb",
  "jerrycan": "/polyhaven/models/metal_jerrycan.glb",
  "toolbox": "/polyhaven/models/metal_toolbox.glb",
  "crystalPlant": "/polyhaven/models/crystalline_iceplant.glb",
  "moonRock": "/polyhaven/models/moon_rock_01.glb"
}

export const SCENARIO_PROFILES:Record<string,ArenaScenarioProfile>={
  "aurelios": {
    "pbr": {
      "base": "/polyhaven/aurelios",
      "repeat": 3.2,
      "backgroundIntensity": 0.66,
      "environmentIntensity": 1.12,
      "blur": 0.035,
      "source": {
        "textureId": "aerial_sand",
        "hdriId": "safari_sunset"
      }
    },
    "architecture": {
      "walls": [
        [
          -9.1,
          0,
          -10.1
        ],
        [
          9.1,
          3.141593,
          -10.1
        ],
        [
          -11.8,
          1.570796,
          -14.2
        ],
        [
          11.8,
          -1.570796,
          -14.2
        ]
      ],
      "gateway": [
        0,
        3.141593,
        -13.15
      ]
    },
    "dressing": [
      {
        "id": "sun-statue-west",
        "asset": "statue",
        "position": [
          -9.4,
          0,
          -7.8
        ],
        "rotationY": 0.35,
        "scale": 1.18,
        "height": 3.15
      },
      {
        "id": "sun-statue-east",
        "asset": "statue",
        "position": [
          9.4,
          0,
          -7.8
        ],
        "rotationY": -0.35,
        "scale": 1.18,
        "height": 3.15
      },
      {
        "id": "sun-boulder-west-a",
        "asset": "boulder",
        "position": [
          -10.8,
          0,
          -11.8
        ],
        "rotationY": 0.9,
        "scale": 1.45,
        "height": 2.1
      },
      {
        "id": "sun-boulder-east-a",
        "asset": "boulder",
        "position": [
          10.8,
          0,
          -11.8
        ],
        "rotationY": -0.7,
        "scale": 1.5,
        "height": 2.15
      },
      {
        "id": "sun-camp-crate-a",
        "asset": "woodCrate",
        "position": [
          -8.3,
          0,
          -12.7
        ],
        "rotationY": 0.25,
        "scale": 1.1,
        "height": 1.1
      },
      {
        "id": "sun-camp-crate-b",
        "asset": "woodCrate",
        "position": [
          8.4,
          0,
          -12.5
        ],
        "rotationY": -0.18,
        "scale": 1.05,
        "height": 1.05
      },
      {
        "id": "sun-expedition-can",
        "asset": "jerrycan",
        "position": [
          -7.7,
          0,
          -9.9
        ],
        "rotationY": 0.55,
        "scale": 1,
        "height": 0.78
      },
      {
        "id": "sun-altar-rock",
        "asset": "moonRock",
        "position": [
          7.8,
          0,
          -10.2
        ],
        "rotationY": -0.42,
        "scale": 1.25,
        "height": 1.5
      }
    ],
    "fx": {
      "particleCount": 260,
      "particleSpread": [
        34,
        10,
        28
      ],
      "particleSpeed": 0.17,
      "haloRadii": [
        5.2,
        8.1,
        11.2
      ],
      "haloHeight": 0.035,
      "beacons": [
        [
          -10.6,
          2.2,
          -12.8
        ],
        [
          10.6,
          2.2,
          -12.8
        ],
        [
          0,
          3.5,
          -14.4
        ]
      ],
      "beaconIntensity": 4.8,
      "beaconDistance": 10.5
    }
  },
  "xyloria": {
    "pbr": {
      "base": "/polyhaven/xyloria",
      "repeat": 4.4,
      "backgroundIntensity": 0.78,
      "environmentIntensity": 1.22,
      "blur": 0.02,
      "source": {
        "textureId": "marble_01",
        "hdriId": "crystal_falls"
      }
    },
    "architecture": {
      "walls": [
        [
          -9.3,
          0.38,
          -10.6
        ],
        [
          9.3,
          -0.38,
          -10.6
        ],
        [
          -12.2,
          1.25,
          -14.8
        ],
        [
          12.2,
          -1.25,
          -14.8
        ]
      ],
      "gateway": [
        0,
        0,
        -13.9
      ]
    },
    "dressing": [
      {
        "id": "crystal-garden-west-a",
        "asset": "crystalPlant",
        "position": [
          -9.6,
          0,
          -8.2
        ],
        "rotationY": 0.1,
        "scale": 1.35,
        "height": 1.8,
        "accent": "#6fffd1"
      },
      {
        "id": "crystal-garden-east-a",
        "asset": "crystalPlant",
        "position": [
          9.6,
          0,
          -8.2
        ],
        "rotationY": -0.15,
        "scale": 1.4,
        "height": 1.85,
        "accent": "#a987ff"
      },
      {
        "id": "crystal-garden-west-b",
        "asset": "crystalPlant",
        "position": [
          -11.2,
          0,
          -11.5
        ],
        "rotationY": 0.7,
        "scale": 1.2,
        "height": 1.6,
        "accent": "#73f7ff"
      },
      {
        "id": "crystal-garden-east-b",
        "asset": "crystalPlant",
        "position": [
          11.2,
          0,
          -11.5
        ],
        "rotationY": -0.6,
        "scale": 1.2,
        "height": 1.6,
        "accent": "#c98cff"
      },
      {
        "id": "lunar-stone-west",
        "asset": "moonRock",
        "position": [
          -8.2,
          0,
          -13.6
        ],
        "rotationY": 0.85,
        "scale": 1.45,
        "height": 1.75
      },
      {
        "id": "lunar-stone-east",
        "asset": "moonRock",
        "position": [
          8.2,
          0,
          -13.6
        ],
        "rotationY": -0.65,
        "scale": 1.5,
        "height": 1.8
      },
      {
        "id": "oracle-statue-west",
        "asset": "statue",
        "position": [
          -10.4,
          0,
          -15.2
        ],
        "rotationY": 0.2,
        "scale": 0.95,
        "height": 2.9,
        "accent": "#73f7dd"
      },
      {
        "id": "oracle-statue-east",
        "asset": "statue",
        "position": [
          10.4,
          0,
          -15.2
        ],
        "rotationY": -0.2,
        "scale": 0.95,
        "height": 2.9,
        "accent": "#9475ff"
      }
    ],
    "fx": {
      "particleCount": 320,
      "particleSpread": [
        36,
        12,
        30
      ],
      "particleSpeed": 0.12,
      "haloRadii": [
        4.8,
        7.4,
        10.6
      ],
      "haloHeight": 0.045,
      "beacons": [
        [
          -10.2,
          2.8,
          -12.6
        ],
        [
          10.2,
          2.8,
          -12.6
        ],
        [
          0,
          4.4,
          -15.2
        ]
      ],
      "beaconIntensity": 5.6,
      "beaconDistance": 11.8
    }
  },
  "capital": {
    "pbr": {
      "base": "/polyhaven/capital",
      "repeat": 5.2,
      "backgroundIntensity": 0.64,
      "environmentIntensity": 1.16,
      "blur": 0.045,
      "source": {
        "textureId": "brushed_concrete",
        "hdriId": "industrial_sunset_02_puresky"
      }
    },
    "architecture": {
      "walls": [
        [
          -9.7,
          0.15,
          -10.8
        ],
        [
          9.7,
          -0.15,
          -10.8
        ],
        [
          -12.4,
          1.570796,
          -14.5
        ],
        [
          12.4,
          -1.570796,
          -14.5
        ]
      ],
      "gateway": [
        0,
        1.570796,
        -14.45
      ]
    },
    "dressing": [
      {
        "id": "capital-barrier-west",
        "asset": "barrier",
        "position": [
          -9.4,
          0,
          -8
        ],
        "rotationY": 0.32,
        "scale": 1.25,
        "height": 1.35
      },
      {
        "id": "capital-barrier-east",
        "asset": "barrier",
        "position": [
          9.4,
          0,
          -8
        ],
        "rotationY": -0.32,
        "scale": 1.25,
        "height": 1.35
      },
      {
        "id": "capital-supply-west",
        "asset": "militaryCrate",
        "position": [
          -8.3,
          0,
          -11.8
        ],
        "rotationY": 0.18,
        "scale": 1.22,
        "height": 1.15
      },
      {
        "id": "capital-supply-east",
        "asset": "militaryCrate",
        "position": [
          8.3,
          0,
          -11.8
        ],
        "rotationY": -0.18,
        "scale": 1.22,
        "height": 1.15
      },
      {
        "id": "capital-reactor-west",
        "asset": "barrel",
        "position": [
          -10.8,
          0,
          -13.1
        ],
        "rotationY": 0.1,
        "scale": 1.15,
        "height": 1.35,
        "accent": "#5bbcff"
      },
      {
        "id": "capital-reactor-east",
        "asset": "barrel",
        "position": [
          10.8,
          0,
          -13.1
        ],
        "rotationY": -0.1,
        "scale": 1.15,
        "height": 1.35,
        "accent": "#5bbcff"
      },
      {
        "id": "capital-field-kit",
        "asset": "toolbox",
        "position": [
          -7.6,
          0,
          -14.6
        ],
        "rotationY": 0.4,
        "scale": 1.08,
        "height": 0.65
      },
      {
        "id": "capital-fuel-kit",
        "asset": "jerrycan",
        "position": [
          7.6,
          0,
          -14.6
        ],
        "rotationY": -0.4,
        "scale": 1.08,
        "height": 0.8
      }
    ],
    "fx": {
      "particleCount": 220,
      "particleSpread": [
        38,
        11,
        32
      ],
      "particleSpeed": 0.09,
      "haloRadii": [
        5.4,
        8.6,
        11.6
      ],
      "haloHeight": 0.03,
      "beacons": [
        [
          -11,
          3.1,
          -13.4
        ],
        [
          11,
          3.1,
          -13.4
        ],
        [
          0,
          5.2,
          -15.5
        ]
      ],
      "beaconIntensity": 5.2,
      "beaconDistance": 12.5
    }
  }
}

export function scenarioProfileForArena(arenaId:string):ArenaScenarioProfile{const family=SCENARIO_FAMILY_BY_ARENA[arenaId]??arenaId;return SCENARIO_PROFILES[family]??SCENARIO_PROFILES.aurelios}
